<template>
  <div class="xihu-home">
    <HeaderBar :width="pageWidth"></HeaderBar>
    <LogoBar
      :width="pageWidth"
      :logo="logo"
      logoHeight="64%"
      :qrcode="qrcode"
    ></LogoBar>
    <TabBar
      :width="pageWidth"
      :tabList="tabList"
      v-model="currentTab"
      @change="onTabChange"
    ></TabBar>
    <router-view class="view"></router-view>
    <NavModule
      :linkList="[]"
      :navList="footerNavList"
      :qrcode="qrcode"
      @click="onNavClick"
    ></NavModule>
    <PageFooter :descriptionList="foorerDesList"></PageFooter>
  </div>
</template>

<script>
import { mapState } from "vuex";
import HeaderBar from "@/components/headerBar";
import LogoBar from "@/components/logoBar";
import TabBar from "@/components/tabBar";
import PageFooter from "@/components/pageFooter";
import NavModule from "@/components/navModule";
import { getNavList } from "@/api/xihu";

const defaultRoute = "xihuHomePage";
export default {
  components: {
    HeaderBar,
    LogoBar,
    TabBar,
    PageFooter,
    NavModule
  },
  data() {
    return {
      currentTab: "home",
      tabList: [
        {
          label: "首页",
          value: "home",
          routeName: "xihuHomePage",
          path: "/home"
        },
        {
          label: "西湖概况",
          value: "overview",
          routeName: "xihuOverview",
          path: "/overview"
        },
        {
          label: "景区门票",
          value: "ticket",
          routeName: "xihuTicketlist",
          path: "/ticketlist"
        },
        {
          label: "西湖礼物",
          value: "present",
          routeName: "xihuShoplist",
          path: "/shoplist"
        }
      ],
      foorerDesList: [
        {
          description:
            "杭州西湖风景名胜区管委会（杭州西溪国家湿地公园管理委员会）｜ 杭州西湖风景名胜区资产经营集团有限公司 丨 杭州西湖风景名胜区文化旅游有限公司 版权所有"
        },
        {
          description: "浙公网安备 33010602002477号"
        },
        {
          description: "技术支持：浙江深大智能科技有限公司"
        }
      ],
      footerLinkList: [
        {
          label: "中国杭州"
        },
        {
          label: "杭州市西湖风景名胜区管委会"
        },
        {
          label: "杭州旅委"
        },
        {
          label: "杭州少儿公园"
        },
        {
          label: "杭州动物园"
        },
        {
          label: "相约西湖"
        },
        {
          label: "杭州外语导游网"
        },
        {
          label: "杭州灵隐寺"
        }
      ],
      footerNavList: []
    };
  },
  computed: {
    ...mapState("privateConfig", ["pageWidth", "logo", "id"]),
    qrcode() {
      return "https://wap.lotsmall.cn/vue/?m_id=" + this.id;
    }
  },
  methods: {
    onTabChange(data) {
      this.$router.push({
        name: data.routeName
      });
    },
    getNavList() {
      getNavList().then(res => {
        this.footerNavList = res;
      });
    },
    onNavClick(data) {
      this.$router.push({
        name: 'xihuCommonDetaill',
        query: {
          aid: data.value
        }
      })
    }
  },
  watch: {
    $route(val) {
      const data = this.tabList.find(item => val.path.includes(item.path));
      if (data) {
        this.currentTab = data.value;
      } else {
        this.currentTab = "";
      }
    }
  },
  created() {
    this.getNavList();
  }
};
</script>

<style scoped lang="scss">
.xihu-home {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  .view {
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/xihu/index.vue